import 'primeicons/primeicons.css';
import 'primereact/resources/themes/saga-blue/theme.css';
import 'primereact/resources/primereact.css';
import 'primeflex/primeflex.css';
import React, { useState, useRef, useContext } from 'react';
import Typography from '@material-ui/core/Typography';
import Actions from '../components/TemplateBots/Actions';
import Parameters from '../components/TemplateBots/Parameters';
import { Link } from 'react-router-dom';
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import { Toolbar } from 'primereact/toolbar';
import ConfigIntegration from '../integrations/ConfigIntegration';
import { EnvContext } from '../components/Context/EnvProvider';
import { useAuthToken } from '../hooks/useAuthToken';
import useQuery from '../hooks/useQuery';
import AuthenticatedLayout from '../components/AuthenticatedLayout';

const configIntegration = new ConfigIntegration();

export default function BotAdvancedConfig() {
    const query = useQuery();
    const templateId = query.get('templateId');
    const toast = useRef(null);
    const [configs, setConfigs] = useState();
    const [parameters, setParameters] = useState(null);
    const { environment } = useContext(EnvContext);
    const { getAccessToken } = useAuthToken();

    const handleSubmit = async () => {
        try {
            const authToken = await getAccessToken();
            const advancedConfig = {
                id: templateId,
                intentsConfig: [...(configs || [])],
                parameters: [...(parameters || [])],
            };

            const json = await configIntegration.saveConfig(
                environment.botApi,
                templateId,
                advancedConfig,
                authToken
            );

            toast.current.show({
                severity: 'success',
                summary: 'Configurações salvas com sucesso!',
                detail: json?.message,
                life: 5000,
            });
        } catch (error) {
            console.error(error);
            toast.current.show({
                severity: 'error',
                summary: 'Erro!',
                detail: 'Erro ao salvar configurações.',
                life: 5000,
            });
        }
    };

    const rightToolbarTemplate = () => (
        <Button
            type="submit"
            label="Salvar"
            icon="pi pi-save"
            className="p-button-success p-mr-2"
            onClick={handleSubmit}
        />
    );

    return (
        <AuthenticatedLayout>
            <Toast ref={toast} />
            <div className="card">
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item">
                            <Link to="/">Home</Link>
                        </li>
                        <li className="breadcrumb-item">
                            <Link to="/ListBotTemplates">Lista de Templates</Link>
                        </li>
                        <li className="breadcrumb-item active">
                            <span>Configurações Avançadas</span>
                        </li>
                    </ol>
                </nav>
            </div>
            <Toolbar className="p-mb-4" right={rightToolbarTemplate} />
            <Typography component="h4" variant="h4" align="left" style={{ marginBottom: 30 }}>
                Ações
            </Typography>
            <Actions templateId={templateId} configs={configs} setConfigs={setConfigs} />
            <Typography
                component="h4"
                variant="h4"
                align="left"
                style={{ marginBottom: 30, marginTop: 30 }}
            >
                Parâmetros de configuração
            </Typography>
            <Parameters
                templateId={templateId}
                parameters={parameters}
                setParameters={setParameters}
            />
            <Toolbar className="p-mb-4" right={rightToolbarTemplate} />
        </AuthenticatedLayout>
    );
}
